import { render } from "./Inspiration.vue?vue&type=template&id=722b47f6&scoped=true"
import script from "./Inspiration.vue?vue&type=script&lang=js"
export * from "./Inspiration.vue?vue&type=script&lang=js"

import "./Inspiration.vue?vue&type=style&index=0&id=722b47f6&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-722b47f6"]])

export default __exports__